export default "__VITE_ASSET__CO1tKkP9__"